// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__YnQIc","progressBar":"styles_progressBar__lFI6s","fillAnimation":"styles_fillAnimation__fIAms"};